"use strict";
/**
 *  Copyright (c) Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the license found in the
 *  LICENSE file in the root directory of this source tree.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var graphql_1 = require("graphql");
var cn = require("classnames");
var ExecuteButton_1 = require("./ExecuteButton");
var ToolbarButton_1 = require("graphiql/dist/components/ToolbarButton");
var QueryEditor_1 = require("./QueryEditor");
var VariableEditor_1 = require("graphiql/dist/components/VariableEditor");
var DocExplorer_1 = require("./DocExplorer");
var CodeMirrorSizer_1 = require("graphiql/dist/utility/CodeMirrorSizer");
var getQueryFacts_1 = require("graphiql/dist/utility/getQueryFacts");
var getSelectedOperationName_1 = require("graphiql/dist/utility/getSelectedOperationName");
var debounce_1 = require("graphiql/dist/utility/debounce");
var find_1 = require("graphiql/dist/utility/find");
var fillLeafs_1 = require("graphiql/dist/utility/fillLeafs");
var elementPosition_1 = require("graphiql/dist/utility/elementPosition");
var introspectionQueries_1 = require("graphiql/dist/utility/introspectionQueries");
var index_1 = require("./util/index");
var QueryHeader_1 = require("./QueryHeader");
var ResultHeader_1 = require("./ResultHeader");
var ResultViewer_1 = require("./ResultViewer");
var ageOfDate_1 = require("./util/ageOfDate");
var SchemaExplorer_1 = require("./SchemaExplorer");
var CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');
var CustomGraphiQL = function (_super) {
    __extends(CustomGraphiQL, _super);
    function CustomGraphiQL(props) {
        var _this = _super.call(this, props) || this;
        _this._updateQueryFacts = debounce_1.default(150, function (query) {
            var queryFacts = getQueryFacts_1.default(_this.state.schema, query);
            if (queryFacts) {
                // Update operation name should any query names change.
                var operationName = getSelectedOperationName_1.default(_this.state.operations, _this.state.operationName, queryFacts.operations);
                // Report changing of operationName if it changed.
                var onEditOperationName = _this.props.onEditOperationName;
                if (onEditOperationName && operationName !== _this.state.operationName) {
                    onEditOperationName(operationName);
                }
                _this.setState(__assign({ operationName: operationName }, queryFacts));
            }
        });
        _this.handleRunQuery = function (selectedOperationName) {
            _this._editorQueryID++;
            var queryID = _this._editorQueryID;
            // Use the edited query after autoCompleteLeafs() runs or,
            // in case autoCompletion fails (the function returns undefined),
            // the current query from the editor.
            var editedQuery = _this.autoCompleteLeafs() || _this.state.query;
            var variables = _this.state.variables;
            var operationName = _this.state.operationName;
            // If an operation was explicitly provided, different from the current
            // operation name, then report that it changed.
            if (selectedOperationName && selectedOperationName !== operationName) {
                operationName = selectedOperationName;
                var onEditOperationName = _this.props.onEditOperationName;
                if (onEditOperationName) {
                    onEditOperationName(operationName);
                }
            }
            try {
                _this.setState({
                    isWaitingForResponse: true,
                    responses: [{ date: null, time: new Date() }],
                    operationName: operationName
                });
                // _fetchQuery may return a subscription.
                var subscription = _this._fetchQuery(editedQuery, variables, operationName, function (result) {
                    if (queryID === _this._editorQueryID) {
                        var isSubscription = false;
                        if (result.isSubscription) {
                            isSubscription = true;
                            delete result.isSubscription;
                        }
                        var responses = void 0;
                        var response = JSON.stringify(result, null, 2);
                        if (isSubscription) {
                            responses = _this.state.responses.filter(function (response) {
                                return response && response.date;
                            }).concat({ date: response, time: new Date() });
                        } else {
                            responses = [{ date: response, time: new Date() }];
                        }
                        _this.setState({
                            isWaitingForResponse: false,
                            responses: responses
                        });
                    }
                });
                _this.setState({ subscription: subscription });
            } catch (error) {
                _this.setState({
                    isWaitingForResponse: false,
                    responses: [{ date: error.message, time: new Date() }]
                });
            }
        };
        _this.handleStopQuery = function () {
            var subscription = _this.state.subscription;
            _this.setState({
                isWaitingForResponse: false,
                subscription: null
            });
            if (subscription) {
                subscription.unsubscribe();
            }
        };
        _this.handlePrettifyQuery = function () {
            var query = graphql_1.print(graphql_1.parse(_this.state.query));
            var editor = _this.queryEditorComponent.getCodeMirror();
            editor.setValue(query);
        };
        _this.handleEditQuery = function (value) {
            if (_this.state.schema) {
                _this._updateQueryFacts(value);
            }
            _this.setState({ query: value });
            if (_this.props.onEditQuery) {
                return _this.props.onEditQuery(value);
            }
            return null;
        };
        _this.handleEditVariables = function (value) {
            _this.setState({ variables: value });
            if (_this.props.onEditVariables) {
                _this.props.onEditVariables(value);
            }
        };
        _this.handleHintInformationRender = function (elem) {
            elem.addEventListener('click', _this._onClickHintInformation);
            var _onRemoveFn;
            elem.addEventListener('DOMNodeRemoved', _onRemoveFn = function onRemoveFn() {
                elem.removeEventListener('DOMNodeRemoved', _onRemoveFn);
                elem.removeEventListener('click', _this._onClickHintInformation);
            });
        };
        _this.handleEditorRunQuery = function () {
            _this._runQueryAtCursor();
        };
        _this._onClickHintInformation = function (event) {
            if (event.target.className === 'typeName') {
                var typeName = event.target.innerHTML;
                var schema = _this.state.schema;
                if (schema) {
                    var type_1 = schema.getType(typeName);
                    if (type_1) {
                        _this.setState({ docExplorerOpen: true }, function () {
                            _this.docExplorerComponent.showDoc(type_1);
                        });
                    }
                }
            }
        };
        _this.handleToggleDocs = function () {
            if (typeof _this.props.onToggleDocs === 'function') {
                _this.props.onToggleDocs(!_this.state.docExplorerOpen);
            }
            _this.setState({ docExplorerOpen: !_this.state.docExplorerOpen });
        };
        _this.handleToggleSchema = function () {
            _this.setState({ schemaExplorerOpen: !_this.state.schemaExplorerOpen });
        };
        _this.handleResizeStart = function (downEvent) {
            if (_this.props.disableResize) {
                return;
            }
            if (!_this._didClickDragBar(downEvent)) {
                return;
            }
            downEvent.preventDefault();
            var offset = downEvent.clientX - elementPosition_1.getLeft(downEvent.target);
            var onMouseMove = function onMouseMove(moveEvent) {
                if (moveEvent.buttons === 0) {
                    return _onMouseUp();
                }
                var editorBar = ReactDOM.findDOMNode(_this.editorBarComponent);
                var leftSize = moveEvent.clientX - elementPosition_1.getLeft(editorBar) - offset;
                var rightSize = editorBar.clientWidth - leftSize;
                _this.setState({ editorFlex: leftSize / rightSize });
            };
            var _onMouseUp = function onMouseUp() {
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', _onMouseUp);
                onMouseMove = null;
                _onMouseUp = null;
            };
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', _onMouseUp);
        };
        _this.handleDocsResizeStart = function (downEvent) {
            downEvent.preventDefault();
            var hadWidth = _this.state.docExplorerWidth;
            var offset = downEvent.clientX - elementPosition_1.getLeft(downEvent.target);
            var onMouseMove = function onMouseMove(moveEvent) {
                if (moveEvent.buttons === 0) {
                    return _onMouseUp2();
                }
                var app = ReactDOM.findDOMNode(_this);
                var cursorPos = moveEvent.clientX - elementPosition_1.getLeft(app) - offset;
                var docsSize = app.clientWidth - cursorPos;
                if (docsSize < 100) {
                    _this.setState({ docExplorerOpen: false });
                } else {
                    _this.setState({
                        docExplorerOpen: true,
                        docExplorerWidth: Math.min(docsSize, 850)
                    });
                }
            };
            var _onMouseUp2 = function onMouseUp() {
                if (!_this.state.docExplorerOpen) {
                    _this.setState({ docExplorerWidth: hadWidth });
                }
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', _onMouseUp2);
                onMouseMove = null;
                _onMouseUp2 = null;
            };
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', _onMouseUp2);
        };
        _this.handleSchemaResizeStart = function (downEvent) {
            downEvent.preventDefault();
            var hadWidth = _this.state.schemaExplorerWidth;
            var offset = downEvent.clientX - elementPosition_1.getLeft(downEvent.target);
            var onMouseMove = function onMouseMove(moveEvent) {
                if (moveEvent.buttons === 0) {
                    return _onMouseUp3();
                }
                var app = ReactDOM.findDOMNode(_this);
                var cursorPos = moveEvent.clientX - elementPosition_1.getLeft(app) - offset;
                var schemaSize = app.clientWidth - cursorPos;
                if (schemaSize < 100) {
                    _this.setState({ schemaExplorerOpen: false });
                } else {
                    _this.setState({
                        schemaExplorerOpen: true,
                        schemaExplorerWidth: Math.min(schemaSize, 850)
                    });
                }
            };
            var _onMouseUp3 = function onMouseUp() {
                if (!_this.state.schemaExplorerOpen) {
                    _this.setState({ schemaExplorerWidth: hadWidth });
                }
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', _onMouseUp3);
                onMouseMove = null;
                _onMouseUp3 = null;
            };
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', _onMouseUp3);
        };
        _this.handleVariableResizeStart = function (downEvent) {
            downEvent.preventDefault();
            var didMove = false;
            var wasOpen = _this.state.variableEditorOpen;
            var hadHeight = _this.state.variableEditorHeight;
            var offset = downEvent.clientY - elementPosition_1.getTop(downEvent.target);
            var onMouseMove = function onMouseMove(moveEvent) {
                if (moveEvent.buttons === 0) {
                    return _onMouseUp4();
                }
                didMove = true;
                var editorBar = ReactDOM.findDOMNode(_this.editorBarComponent);
                var topSize = moveEvent.clientY - elementPosition_1.getTop(editorBar) - offset;
                var bottomSize = editorBar.clientHeight - topSize;
                if (bottomSize < 60) {
                    _this.setState({
                        variableEditorOpen: false,
                        variableEditorHeight: hadHeight
                    });
                } else {
                    _this.setState({
                        variableEditorOpen: true,
                        variableEditorHeight: bottomSize
                    });
                }
            };
            var _onMouseUp4 = function onMouseUp() {
                if (!didMove) {
                    _this.setState({ variableEditorOpen: !wasOpen });
                }
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', _onMouseUp4);
                onMouseMove = null;
                _onMouseUp4 = null;
            };
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', _onMouseUp4);
        };
        _this.handleDownloadJSON = function () {
            index_1.download(_this.state.responses[0].date, 'result.json', 'application/json');
        };
        // Ensure props are correct
        if (typeof props.fetcher !== 'function') {
            throw new TypeError('CustomGraphiQL requires a fetcher function.');
        }
        // Cache the storage instance
        _this._storage = props.storage || typeof window !== 'undefined' ? window.localStorage : {
            setItem: function setItem() {
                return null;
            },
            removeItem: function removeItem() {
                return null;
            },
            getItem: function getItem() {
                return null;
            }
        };
        // Determine the initial query to display.
        var query = props.query !== undefined ? props.query : _this._storageGet('query') !== null ? _this._storageGet('query') : props.defaultQuery !== undefined ? props.defaultQuery : defaultQuery;
        // Get the initial query facts.
        var queryFacts = getQueryFacts_1.default(props.schema, query);
        // Determine the initial variables to display.
        var variables = props.variables !== undefined ? props.variables : _this._storageGet('variables');
        // Determine the initial operationName to use.
        var operationName = props.operationName !== undefined ? props.operationName : getSelectedOperationName_1.default(null, _this._storageGet('operationName'), queryFacts && queryFacts.operations);
        // Initialize state
        _this.state = __assign({ schema: props.schema, query: query,
            variables: variables,
            operationName: operationName, responses: props.responses || [], editorFlex: Number(_this._storageGet('editorFlex')) || 1, variableEditorOpen: Boolean(variables), variableEditorHeight: Number(_this._storageGet('variableEditorHeight')) || 200, docExplorerOpen: _this._storageGet('docExplorerOpen') === 'true' || false, docExplorerWidth: Number(_this._storageGet('docExplorerWidth')) || 350, schemaExplorerOpen: false, schemaExplorerWidth: Number(_this._storageGet('schemaExplorerWidth')) || 350, isWaitingForResponse: false, subscription: null }, queryFacts);
        // Ensure only the last executed editor query is rendered.
        _this._editorQueryID = 0;
        // Subscribe to the browser window closing, treating it as an unmount.
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
            window.addEventListener('beforeunload', function () {
                return _this.componentWillUnmount();
            });
        }
        return _this;
    }
    CustomGraphiQL.prototype.componentDidMount = function () {
        // Ensure a form of a schema exists (including `null`) and
        // if not, fetch one using an introspection query.
        this._ensureOfSchema();
        // Utility for keeping CodeMirror correctly sized.
        this.codeMirrorSizer = new CodeMirrorSizer_1.default();
        global['g'] = this;
    };
    CustomGraphiQL.prototype.componentWillReceiveProps = function (nextProps) {
        var nextSchema = this.state.schema;
        var nextQuery = this.state.query;
        var nextVariables = this.state.variables;
        var nextOperationName = this.state.operationName;
        var nextResponses = this.state.responses;
        if (nextProps.schema !== undefined) {
            nextSchema = nextProps.schema;
        }
        if (nextProps.query !== undefined && (this.props.rerenderQuery || nextProps.rerenderQuery)) {
            nextQuery = nextProps.query;
        }
        if (nextProps.variables !== undefined) {
            nextVariables = nextProps.variables;
        }
        if (nextProps.operationName !== undefined) {
            nextOperationName = nextProps.operationName;
        }
        if (nextProps.responses !== undefined) {
            nextResponses = nextProps.responses;
        }
        if (nextSchema !== this.state.schema || nextQuery !== this.state.query || nextOperationName !== this.state.operationName) {
            this._updateQueryFacts(nextQuery);
        }
        this.setState({
            schema: nextSchema,
            query: nextQuery,
            variables: nextVariables,
            operationName: nextOperationName,
            responses: nextResponses
        });
    };
    CustomGraphiQL.prototype.componentDidUpdate = function () {
        // If this update caused DOM nodes to have changed sizes, update the
        // corresponding CodeMirror instance sizes to match.
        var components = [this.queryEditorComponent, this.variableEditorComponent];
        this.codeMirrorSizer.updateSizes(components);
        if (this.resultComponent && Boolean(this.state.subscription)) {
            this.resultComponent.scrollTop = this.resultComponent.scrollHeight;
        }
    };
    // When the component is about to unmount, store any persistable state, such
    // that when the component is remounted, it will use the last used values.
    CustomGraphiQL.prototype.componentWillUnmount = function () {
        this._storageSet('query', this.state.query);
        this._storageSet('variables', this.state.variables);
        this._storageSet('operationName', this.state.operationName);
        this._storageSet('editorFlex', this.state.editorFlex);
        this._storageSet('variableEditorHeight', this.state.variableEditorHeight);
        this._storageSet('docExplorerWidth', this.state.docExplorerWidth);
        this._storageSet('docExplorerOpen', this.state.docExplorerOpen);
    };
    CustomGraphiQL.prototype.render = function () {
        var _this = this;
        var children = React.Children.toArray(this.props.children);
        // const logo =
        //   find(children, child => child.type === CustomGraphiQL.Logo) ||
        {}
        {}
        {}
        {}
        var footer = find_1.default(children, function (child) {
            return child.type === CustomGraphiQL.Footer;
        });
        var queryWrapStyle = {
            WebkitFlex: this.state.editorFlex,
            flex: this.state.editorFlex
        };
        var docWrapStyle = {
            height: '100%',
            // display: this.state.docExplorerOpen ? 'block':'none',
            width: this.state.docExplorerOpen ? this.state.docExplorerWidth : 0
        };
        var schemaWrapStyle = {
            height: '100%',
            // display: this.state.docExplorerOpen ? 'block':'none',
            width: this.state.schemaExplorerOpen ? this.state.schemaExplorerWidth : 0
        };
        var docExplorerWrapClasses = 'docExplorerWrap' + (this.state.docExplorerWidth < 200 ? ' doc-explorer-narrow' : '');
        var variableOpen = this.state.variableEditorOpen;
        var variableStyle = {
            height: variableOpen ? this.state.variableEditorHeight : null
        };
        var subscriptionResponse = this.state.responses.length > 1;
        var Tether = this.props.tether;
        return React.createElement(
            "div",
            { className: "graphiql-container", "data-jsx": 491787499
            },
            React.createElement(_style2.default, {
                styleId: 1041892734,
                css: ".graphiql-container[data-jsx=\"491787499\"] {font-family: Open Sans,sans-serif;}.docs-button[data-jsx=\"491787499\"],.schema-button[data-jsx=\"491787499\"] {padding-bottom: 8px;-webkit-transform: rotate(-90deg);transform: rotate(-90deg);left: -44px;top: 195px;}div.schema-button[data-jsx=\"491787499\"] {left: -53px;top: 120px;}.queryWrap[data-jsx=\"491787499\"] {border-top: 8px solid rgba(23, 42, 58, 1);}.graphiql-button[data-jsx=\"491787499\"] {top: -57px;right: 25px;padding: 5px 9px 6px 9px;letter-spacing: 0.53px;z-index: 2;}.download-button[data-jsx=\"491787499\"] {right: 25px;padding: 5px 9px 6px 9px;letter-spacing: 0.53px;z-index: 2;background-color: rgba(15, 32, 46, 1) !important;top: auto !important;top: initial !important;bottom: 21px !important;}.intro[data-jsx=\"491787499\"] {font-family: 'Source Code Pro',              'Consolas',              'Inconsolata',              'Droid Sans Mono',              'Monaco',              monospace;letter-spacing: 0.6px;width: 235px;}.result-window.disableResize[data-jsx=\"491787499\"] .CodeMirror-gutters {cursor: default !important;}.subscription-time[data-jsx=\"491787499\"] {height: 17px;margin-top: 12px;margin-bottom: 4px}.subscription-time[data-jsx=\"491787499\"][data-jsx=\"491787499\"]:before {content: \"\";top: 9px;left: 95px;border-top: 1px solid rgba(255, 255, 255, .2);}.subscription-time-text[data-jsx=\"491787499\"] {padding-left: 15px;}.listening[data-jsx=\"491787499\"] {font-family: 'Source Code Pro',              'Consolas',              'Inconsolata',              'Droid Sans Mono',              'Monaco',              monospace;letter-spacing: 0.6px;padding-left: 24px;padding-bottom: 30px;}.onboarding-hint.step1[data-jsx=\"491787499\"] {top: 207px;left: 90px;}.onboarding-hint.step2[data-jsx=\"491787499\"] {top: 207px;left: 90px;}.absolute,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.intro[data-jsx=\"491787499\"],\n.subscription-time[data-jsx=\"491787499\"][data-jsx=\"491787499\"]:before,\n.listening[data-jsx=\"491787499\"],\n.onboarding-hint[data-jsx=\"491787499\"] {position: absolute;}.white,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"] {color: #fff;}.bgGreen,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"] {background-color: #27ae60;}.pa6,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"] {padding: 6px;}.br2,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.onboarding-hint[data-jsx=\"491787499\"] {border-radius: 2px;}.z2,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"] {z-index: 2;}.ttu,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"] {text-transform: uppercase;}.fw6,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"] {font-weight: 600;}.f14,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"] {font-size: 14px;}.ph10,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"] {padding-left: 10px;padding-right: 10px;}.pointer:hover,\n.docs-button[data-jsx=\"491787499\"]:hover,\n.schema-button[data-jsx=\"491787499\"]:hover,\n.graphiql-button[data-jsx=\"491787499\"]:hover,\n.download-button[data-jsx=\"491787499\"]:hover {cursor: pointer;}.bgLightOrange,\ndiv.schema-button[data-jsx=\"491787499\"] {background-color: #f18f01;}.relative,\n.queryWrap[data-jsx=\"491787499\"],\n.subscription-time[data-jsx=\"491787499\"] {position: relative;}.white50,\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.subscription-time-text[data-jsx=\"491787499\"] {color: hsla(0,0%,100%,.5);}.bgDarkBlue,\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.result-window[data-jsx=\"491787499\"],\n.subscription-time-text[data-jsx=\"491787499\"] {background-color: #172a3a;}.ttu,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"] {text-transform: uppercase;}.f14,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"] {font-size: 14px;}.fw6,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"] {font-weight: 600;}.br2,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.onboarding-hint[data-jsx=\"491787499\"] {border-radius: 2px;}.pointer:hover,\n.docs-button[data-jsx=\"491787499\"]:hover,\n.schema-button[data-jsx=\"491787499\"]:hover,\n.graphiql-button[data-jsx=\"491787499\"]:hover,\n.download-button[data-jsx=\"491787499\"]:hover {cursor: pointer;}.absolute,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.intro[data-jsx=\"491787499\"],\n.subscription-time[data-jsx=\"491787499\"][data-jsx=\"491787499\"]:before,\n.listening[data-jsx=\"491787499\"],\n.onboarding-hint[data-jsx=\"491787499\"] {position: absolute;}.white50,\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.subscription-time-text[data-jsx=\"491787499\"] {color: hsla(0,0%,100%,.5);}.bgDarkBlue,\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.result-window[data-jsx=\"491787499\"],\n.subscription-time-text[data-jsx=\"491787499\"] {background-color: #172a3a;}.ttu,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"] {text-transform: uppercase;}.f14,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"] {font-size: 14px;}.fw6,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"] {font-weight: 600;}.br2,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.onboarding-hint[data-jsx=\"491787499\"] {border-radius: 2px;}.pointer:hover,\n.docs-button[data-jsx=\"491787499\"]:hover,\n.schema-button[data-jsx=\"491787499\"]:hover,\n.graphiql-button[data-jsx=\"491787499\"]:hover,\n.download-button[data-jsx=\"491787499\"]:hover {cursor: pointer;}.absolute,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.intro[data-jsx=\"491787499\"],\n.subscription-time[data-jsx=\"491787499\"][data-jsx=\"491787499\"]:before,\n.listening[data-jsx=\"491787499\"],\n.onboarding-hint[data-jsx=\"491787499\"] {position: absolute;}.absolute,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.intro[data-jsx=\"491787499\"],\n.subscription-time[data-jsx=\"491787499\"][data-jsx=\"491787499\"]:before,\n.listening[data-jsx=\"491787499\"],\n.onboarding-hint[data-jsx=\"491787499\"] {position: absolute;}.tlCenter,\n.intro[data-jsx=\"491787499\"] {transform: translate(-50%,-50%);}.top50,\n.intro[data-jsx=\"491787499\"] {top: 50%;}.left50,\n.intro[data-jsx=\"491787499\"] {left: 50%;}.white20,\n.intro[data-jsx=\"491787499\"] {color: hsla(0,0%,100%,.2);}.f16,\n.intro[data-jsx=\"491787499\"],\n.listening[data-jsx=\"491787499\"] {font-size: 16px;}.tc,\n.intro[data-jsx=\"491787499\"] {text-align: center;}.bgDarkBlue,\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.result-window[data-jsx=\"491787499\"],\n.subscription-time-text[data-jsx=\"491787499\"] {background-color: #172a3a;}.nosb,\n.result-window[data-jsx=\"491787499\"] {-ms-overflow-style: none;}.nosb::-webkit-scrollbar,\n.result-window[data-jsx=\"491787499\"]::-webkit-scrollbar {display: none;}.relative,\n.queryWrap[data-jsx=\"491787499\"],\n.subscription-time[data-jsx=\"491787499\"] {position: relative;}.absolute,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.intro[data-jsx=\"491787499\"],\n.subscription-time[data-jsx=\"491787499\"][data-jsx=\"491787499\"]:before,\n.listening[data-jsx=\"491787499\"],\n.onboarding-hint[data-jsx=\"491787499\"] {position: absolute;}.w100,\n.subscription-time[data-jsx=\"491787499\"][data-jsx=\"491787499\"]:before {width: 100%;}.bgDarkBlue,\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.result-window[data-jsx=\"491787499\"],\n.subscription-time-text[data-jsx=\"491787499\"] {background-color: #172a3a;}.white50,\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.subscription-time-text[data-jsx=\"491787499\"] {color: hsla(0,0%,100%,.5);}.f12,\n.subscription-time-text[data-jsx=\"491787499\"] {font-size: 12px;}.f16,\n.intro[data-jsx=\"491787499\"],\n.listening[data-jsx=\"491787499\"] {font-size: 16px;}.white40,\n.listening[data-jsx=\"491787499\"] {color: hsla(0,0%,100%,.4);}.absolute,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.intro[data-jsx=\"491787499\"],\n.subscription-time[data-jsx=\"491787499\"][data-jsx=\"491787499\"]:before,\n.listening[data-jsx=\"491787499\"],\n.onboarding-hint[data-jsx=\"491787499\"] {position: absolute;}.bottom0,\n.listening[data-jsx=\"491787499\"] {bottom: 0;}.absolute,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.intro[data-jsx=\"491787499\"],\n.subscription-time[data-jsx=\"491787499\"][data-jsx=\"491787499\"]:before,\n.listening[data-jsx=\"491787499\"],\n.onboarding-hint[data-jsx=\"491787499\"] {position: absolute;}.br2,\n.docs-button[data-jsx=\"491787499\"],\n.schema-button[data-jsx=\"491787499\"],\n.graphiql-button[data-jsx=\"491787499\"],\n.download-button[data-jsx=\"491787499\"],\n.onboarding-hint[data-jsx=\"491787499\"] {border-radius: 2px;}.z999,\n.onboarding-hint[data-jsx=\"491787499\"] {z-index: 999;}"
            }),
            React.createElement(_style2.default, {
                styleId: 1032694800,
                css: "\n          .query-header-enter {\n            opacity: 0.01;\n          }\n\n          .query-header-enter.query-header-enter-active {\n            opacity: 1;\n            -webkit-transition: opacity 500ms ease-in;\n            transition: opacity 500ms ease-in;\n          }\n\n          .query-header-leave {\n            opacity: 1;\n          }\n\n          .query-header-leave.query-header-leave-active {\n            opacity: 0.01;\n            -webkit-transition: opacity 300ms ease-in;\n            transition: opacity 300ms ease-in;\n          }\n        "
            }),
            React.createElement(
                "div",
                { className: "editorWrap", "data-jsx": 491787499
                },
                React.createElement(
                    "div",
                    { ref: function ref(n) {
                            _this.editorBarComponent = n;
                        }, className: "editorBar", onMouseDown: this.handleResizeStart, "data-jsx": 491787499
                    },
                    React.createElement(
                        "div",
                        { className: "queryWrap", style: queryWrapStyle, "data-jsx": 491787499
                        },
                        this.props.disableAnimation ? React.createElement(QueryHeader_1.default, { selectedEndpoint: this.props.selectedEndpoint, onChangeEndpoint: this.props.onChangeEndpoint, onPrettify: this.handlePrettifyQuery, showEndpoints: this.props.showEndpoints, showQueryTitle: this.props.showQueryTitle }) : React.createElement(
                            CSSTransitionGroup,
                            { transitionName: "query-header", transitionEnterTimeout: 500, transitionLeaveTimeout: 300 },
                            !this.props.disableQueryHeader && React.createElement(QueryHeader_1.default, { selectedEndpoint: this.props.selectedEndpoint, onChangeEndpoint: this.props.onChangeEndpoint, onPrettify: this.handlePrettifyQuery, showEndpoints: this.props.showEndpoints, showQueryTitle: this.props.showQueryTitle })
                        ),
                        React.createElement(QueryEditor_1.QueryEditor, { ref: function ref(n) {
                                _this.queryEditorComponent = n;
                            }, schema: this.state.schema, value: this.state.query, onEdit: this.handleEditQuery, onHintInformationRender: this.handleHintInformationRender, onRunQuery: this.handleEditorRunQuery, disableAutofocus: this.props.disableAutofocus, hideLineNumbers: this.props.hideLineNumbers, hideGutters: this.props.hideGutters, readOnly: this.props.readonly }),
                        React.createElement(
                            "div",
                            { className: "variable-editor", style: variableStyle, "data-jsx": 491787499
                            },
                            this.props.showCodeGeneration && React.createElement(
                                "div",
                                { className: "graphiql-button", onClick: this.props.onClickCodeGeneration, "data-jsx": 491787499
                                },
                                "Generate Code"
                            ),
                            React.createElement(
                                "div",
                                { className: "variable-editor-title", style: { cursor: variableOpen ? 'row-resize' : 'n-resize' }, onMouseDown: this.handleVariableResizeStart, "data-jsx": 491787499
                                },
                                'Query Variables'
                            ),
                            React.createElement(VariableEditor_1.VariableEditor, { ref: function ref(n) {
                                    _this.variableEditorComponent = n;
                                }, value: this.state.variables, variableToType: this.state.variableToType, onEdit: this.handleEditVariables, onHintInformationRender: this.handleHintInformationRender, onRunQuery: this.handleEditorRunQuery })
                        ),
                        ['STEP3_UNCOMMENT_DESCRIPTION', 'STEP3_ENTER_MUTATION1_VALUES', 'STEP3_ENTER_MUTATION2_VALUE'].indexOf(this.props.onboardingStep || '') > -1 && React.createElement(
                            Tether,
                            { steps: [{
                                    step: 'STEP3_UNCOMMENT_DESCRIPTION',
                                    title: 'Uncomment the description',
                                    description: 'To add the description to the query, just remove the #'
                                }, {
                                    step: 'STEP3_ENTER_MUTATION1_VALUES',
                                    title: 'This is a mutation',
                                    description: 'Enter data for the imageUrl and the description',
                                    buttonText: 'Autofill Data'
                                }, {
                                    step: 'STEP3_ENTER_MUTATION2_VALUE',
                                    title: 'Lets add some more data',
                                    description: 'Enter data for the imageUrl and the description',
                                    buttonText: 'Autofill Data'
                                }], onClick: function onClick() {
                                    if (_this.props.onboardingStep.startsWith('STEP3_ENTER_MUTATION') && typeof _this.props.autofillMutation === 'function') {
                                        _this.props.autofillMutation();
                                    }
                                } },
                            React.createElement("div", { className: cn('onboarding-hint', {
                                    'step1': this.props.onboardingStep === 'STEP3_UNCOMMENT_DESCRIPTION',
                                    'step2': this.props.onboardingStep === 'STEP3_ENTER_MUTATION1_VALUES' || this.props.onboardingStep === 'STEP3_ENTER_MUTATION2_VALUE'
                                }), "data-jsx": 491787499
                            })
                        )
                    ),
                    !this.props.queryOnly && React.createElement(
                        "div",
                        { className: "resultWrap", "data-jsx": 491787499
                        },
                        React.createElement(ResultHeader_1.default, { showViewAs: this.props.showViewAs, showSelectUser: this.props.showSelectUser, selectedViewer: this.props.selectedViewer, onChangeViewer: this.props.onChangeViewer, showResponseTitle: this.props.showResponseTitle }),
                        this.props.tether ? React.createElement(
                            Tether,
                            { offsetX: 18, offsetY: 25, steps: [{
                                    step: 'STEP3_RUN_QUERY1',
                                    title: 'Execute your first query',
                                    description: 'You just wrote your first GraphQL Query! Click here to execute it.'
                                }, {
                                    step: 'STEP3_RUN_MUTATION1',
                                    title: 'Run your first mutation',
                                    description: 'Awesome! You just wrote your first GraphQL Mutation. Click here to execute it'
                                }, {
                                    step: 'STEP3_RUN_MUTATION2',
                                    title: 'Lets add more data'
                                }, {
                                    step: 'STEP3_RUN_QUERY2',
                                    title: 'Let\'s see how the data changed',
                                    description: 'After adding data with the mutations, lets' + ' see how the result of the query changes'
                                }] },
                            React.createElement(ExecuteButton_1.ExecuteButton, { isRunning: Boolean(this.state.subscription), onRun: this.handleRunQuery, onStop: this.handleStopQuery, operations: this.state.operations })
                        ) : React.createElement(ExecuteButton_1.ExecuteButton, { isRunning: Boolean(this.state.subscription), onRun: this.handleRunQuery, onStop: this.handleStopQuery, operations: this.state.operations }),
                        this.state.isWaitingForResponse && React.createElement(
                            "div",
                            { className: "spinner-container", "data-jsx": 491787499
                            },
                            React.createElement("div", { className: "spinner", "data-jsx": 491787499
                            })
                        ),
                        React.createElement(
                            "div",
                            { className: 'result-window' + (this.props.disableResize ? ' disableResize' : ''), ref: function ref(c) {
                                    _this.resultComponent = c;
                                }, "data-jsx": 491787499
                            },
                            this.state.responses.filter(function (res) {
                                return res && res.date;
                            }).map(function (response, index) {
                                return React.createElement(
                                    "div",
                                    { key: response.time, "data-jsx": 491787499
                                    },
                                    subscriptionResponse && response.time && React.createElement(
                                        "div",
                                        { className: "subscription-time", "data-jsx": 491787499
                                        },
                                        React.createElement(
                                            "div",
                                            { className: "subscription-time-text", "data-jsx": 491787499
                                            },
                                            ageOfDate_1.default(response.time)
                                        )
                                    ),
                                    React.createElement(ResultViewer_1.ResultViewer, { value: response.date, hideGutters: _this.props.hideGutters })
                                );
                            })
                        ),
                        footer,
                        !this.state.responses || this.state.responses.length === 0 && React.createElement(
                            "div",
                            { className: "intro", "data-jsx": 491787499
                            },
                            "Hit the Play Button to get a response here"
                        ),
                        Boolean(this.state.subscription) && React.createElement(
                            "div",
                            { className: "listening", "data-jsx": 491787499
                            },
                            "Listening \u2026"
                        ),
                        this.state.responses && this.state.responses.length > 0 && this.props.showDownloadJsonButton && React.createElement(
                            "div",
                            { className: "download-button", onClick: this.handleDownloadJSON, "data-jsx": 491787499
                            },
                            "Download JSON"
                        )
                    )
                )
            ),
            (this.props.queryOnly ? this.props.showDocs : true) && React.createElement(
                "div",
                { className: docExplorerWrapClasses, style: docWrapStyle, "data-jsx": 491787499
                },
                React.createElement(
                    "div",
                    { className: "docs-button " + (!this.state.docExplorerOpen && 'inactive'), onClick: this.handleToggleDocs, "data-jsx": 491787499
                    },
                    "Docs"
                ),
                React.createElement("div", { className: "docExplorerResizer", onMouseDown: this.handleDocsResizeStart, "data-jsx": 491787499
                }),
                this.state.docExplorerOpen && React.createElement(DocExplorer_1.DocExplorer, { ref: function ref(c) {
                        _this.docExplorerComponent = c;
                    }, schema: this.state.schema, open: this.state.docExploreOpen })
            ),
            this.props.showSchema && React.createElement(
                "div",
                { className: docExplorerWrapClasses, style: schemaWrapStyle, "data-jsx": 491787499
                },
                React.createElement(
                    "div",
                    { className: "schema-button " + (!this.state.schemaExplorerOpen && 'inactive'), onClick: this.handleToggleSchema, "data-jsx": 491787499
                    },
                    "Schema"
                ),
                React.createElement("div", { className: "docExplorerResizer", onMouseDown: this.handleSchemaResizeStart, "data-jsx": 491787499
                }),
                this.state.schemaExplorerOpen && React.createElement(SchemaExplorer_1.default, { ref: function ref(c) {
                        _this.docExplorerComponent = c;
                    }, idl: this.props.schemaIdl, modelName: this.props.schemaModelName })
            )
        );
    };
    /**
     * Inspect the query, automatically filling in selection sets for non-leaf
     * fields which do not yet have them.
     *
     * @public
     */
    CustomGraphiQL.prototype.autoCompleteLeafs = function () {
        var _a = fillLeafs_1.fillLeafs(this.state.schema, this.state.query, this.props.getDefaultFieldNames),
            insertions = _a.insertions,
            result = _a.result;
        if (insertions && insertions.length > 0) {
            var editor_1 = this.queryEditorComponent.getCodeMirror();
            editor_1.operation(function () {
                var cursor = editor_1.getCursor();
                var cursorIndex = editor_1.indexFromPos(cursor);
                editor_1.setValue(result);
                var added = 0;
                var markers = insertions.map(function (_a) {
                    var index = _a.index,
                        str = _a.str;
                    return editor_1.markText(editor_1.posFromIndex(index + added), editor_1.posFromIndex(index + (added += str.length)), {
                        className: 'autoInsertedLeaf',
                        clearOnEnter: true,
                        title: 'Automatically added leaf fields'
                    });
                });
                setTimeout(function () {
                    return markers.forEach(function (marker) {
                        return marker.clear();
                    });
                }, 7000);
                var newCursorIndex = cursorIndex;
                insertions.forEach(function (_a) {
                    var index = _a.index,
                        str = _a.str;
                    if (index < cursorIndex) {
                        newCursorIndex += str.length;
                    }
                });
                editor_1.setCursor(editor_1.posFromIndex(newCursorIndex));
            });
        }
        return result;
    };
    // Private methods
    CustomGraphiQL.prototype._ensureOfSchema = function () {
        var _this = this;
        // Only perform introspection if a schema is not provided (undefined)
        if (this.state.schema !== undefined) {
            return;
        }
        var fetcher = this.props.fetcher;
        var fetch = observableToPromise(fetcher({ query: introspectionQueries_1.introspectionQuery }));
        if (!isPromise(fetch)) {
            this.setState({
                responses: [{ date: 'Fetcher did not return a Promise for introspection.', time: new Date() }]
            });
            return;
        }
        fetch.then(function (result) {
            if (result.data) {
                return result;
            }
            // Try the stock introspection query first, falling back on the
            // sans-subscriptions query for services which do not yet support it.
            var fetch2 = observableToPromise(fetcher({
                query: introspectionQueries_1.introspectionQuerySansSubscriptions
            }));
            if (!isPromise(fetch)) {
                throw new Error('Fetcher did not return a Promise for introspection.');
            }
            return fetch2;
        }).then(function (result) {
            // If a schema was provided while this fetch was underway, then
            // satisfy the race condition by respecting the already
            // provided schema.
            if (_this.state.schema !== undefined) {
                return;
            }
            if (result && result.data) {
                var schema = graphql_1.buildClientSchema(result.data);
                var queryFacts = getQueryFacts_1.default(schema, _this.state.query);
                _this.setState(__assign({ schema: schema }, queryFacts));
            } else {
                var responseString = typeof result === 'string' ? result : JSON.stringify(result, null, 2);
                _this.setState({
                    // Set schema to `null` to explicitly indicate that no schema exists.
                    schema: null,
                    responses: [{ date: responseString, time: new Date() }]
                });
            }
        }).catch(function (error) {
            _this.setState({
                schema: null,
                responses: [{ date: error && String(error.stack || error), time: new Date() }]
            });
        });
    };
    CustomGraphiQL.prototype._storageGet = function (name) {
        if (this._storage) {
            var value = this._storage.getItem('graphiql:' + name);
            // Clean up any inadvertently saved null/undefined values.
            if (value === 'null' || value === 'undefined') {
                this._storage.removeItem('graphiql:' + name);
            } else {
                return value;
            }
        }
    };
    CustomGraphiQL.prototype._storageSet = function (name, value) {
        if (this._storage) {
            if (value) {
                this._storage.setItem('graphiql:' + name, value);
            } else {
                this._storage.removeItem('graphiql:' + name);
            }
        }
    };
    CustomGraphiQL.prototype._fetchQuery = function (query, variables, operationName, cb) {
        var _this = this;
        var fetcher = this.props.fetcher;
        var jsonVariables = null;
        try {
            jsonVariables = variables && variables.trim() !== '' ? JSON.parse(variables) : null;
        } catch (error) {
            throw new Error("Variables are invalid JSON: " + error.message + ".");
        }
        if ((typeof jsonVariables === "undefined" ? "undefined" : _typeof(jsonVariables)) !== 'object') {
            throw new Error('Variables are not a JSON object.');
        }
        var fetch = fetcher({
            query: query,
            variables: jsonVariables,
            operationName: operationName
        });
        if (isPromise(fetch)) {
            // If fetcher returned a Promise, then call the callback when the promise
            // resolves, otherwise handle the error.
            fetch.then(cb).catch(function (error) {
                _this.setState({
                    isWaitingForResponse: false,
                    responses: [{ date: error && String(error.stack || error), time: new Date() }]
                });
            });
        } else if (isObservable(fetch)) {
            // If the fetcher returned an Observable, then subscribe to it, calling
            // the callback on each next value, and handling both errors and the
            // completion of the Observable. Returns a Subscription object.
            var subscription = fetch.subscribe({
                next: cb,
                error: function error(_error) {
                    _this.setState({
                        isWaitingForResponse: false,
                        responses: [{ date: _error && String(_error.stack || _error), time: new Date() }],
                        subscription: null
                    });
                },
                complete: function complete() {
                    _this.setState({
                        isWaitingForResponse: false,
                        subscription: null
                    });
                }
            });
            return subscription;
        } else {
            throw new Error('Fetcher did not return Promise or Observable.');
        }
    };
    CustomGraphiQL.prototype._runQueryAtCursor = function () {
        if (this.state.subscription) {
            this.handleStopQuery();
            return;
        }
        var operationName;
        var operations = this.state.operations;
        if (operations) {
            var editor = this.queryEditorComponent.getCodeMirror();
            if (editor.hasFocus()) {
                var cursor = editor.getCursor();
                var cursorIndex = editor.indexFromPos(cursor);
                // Loop through all operations to see if one contains the cursor.
                for (var i = 0; i < operations.length; i++) {
                    var operation = operations[i];
                    if (operation.loc.start <= cursorIndex && operation.loc.end >= cursorIndex) {
                        operationName = operation.name && operation.name.value;
                        break;
                    }
                }
            }
        }
        this.handleRunQuery(operationName);
    };
    CustomGraphiQL.prototype._didClickDragBar = function (event) {
        // Only for primary unmodified clicks
        if (event.button !== 0 || event.ctrlKey) {
            return false;
        }
        var target = event.target;
        // We use codemirror's gutter as the drag bar.
        if (target.className.indexOf && target.className.indexOf('CodeMirror-gutter') !== 0) {
            return false;
        }
        // Specifically the result window's drag bar.
        var resultWindow = ReactDOM.findDOMNode(this.resultComponent);
        while (target) {
            if (target === resultWindow) {
                return true;
            }
            target = target.parentNode;
        }
        return false;
    };
    return CustomGraphiQL;
}(React.Component);
exports.CustomGraphiQL = CustomGraphiQL;
// Configure the UI by providing this Component as a child of CustomGraphiQL.
CustomGraphiQL.Logo = function GraphiQLLogo(props) {
    return React.createElement(
        "div",
        { className: "title" },
        props.children || React.createElement(
            "span",
            null,
            'Graph',
            React.createElement(
                "em",
                null,
                'i'
            ),
            'QL'
        )
    );
};
// Configure the UI by providing this Component as a child of CustomGraphiQL.
CustomGraphiQL.Toolbar = function GraphiQLToolbar(props) {
    return React.createElement(
        "div",
        { className: "toolbar" },
        props.children
    );
};
// Add a button to the Toolbar.
CustomGraphiQL.ToolbarButton = ToolbarButton_1.ToolbarButton;
// Configure the UI by providing this Component as a child of CustomGraphiQL.
CustomGraphiQL.Footer = function GraphiQLFooter(props) {
    return React.createElement(
        "div",
        { className: "footer" },
        props.children
    );
};
var defaultQuery = "# Welcome to Graphcool's custom GraphiQL \u270C\n#\n# GraphiQL is an in-browser IDE for writing, validating, and\n# testing GraphQL queries.\n#\n# In Graphcool's custom GraphiQL you can additionally generate\n# code examples and download the result JSON.\n#\n# Type queries into this side of the screen, and you will\n# see intelligent typeaheads aware of the current GraphQL type schema and\n# live syntax and validation errors highlighted within the text.\n#\n# To bring up the auto-complete at any point, just press Ctrl-Space.\n#\n# Press the run button above, or Cmd-Enter to execute the query, and the result\n# will appear in the pane to the right.\n\n";
// Duck-type promise detection.
function isPromise(value) {
    return (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && typeof value.then === 'function';
}
// Duck-type Observable.take(1).toPromise()
function observableToPromise(observable) {
    if (!isObservable(observable)) {
        return observable;
    }
    return new Promise(function (resolve, reject) {
        var subscription = observable.subscribe(function (v) {
            resolve(v);
            subscription.unsubscribe();
        }, reject, function () {
            reject(new Error('no value resolved'));
        });
    });
}
// Duck-type observable detection.
function isObservable(value) {
    return (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && typeof value.subscribe === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/GraphiQL/CustomGraphiQL.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/GraphiQL/CustomGraphiQL.js
// module chunks = 0